import APIConfiguration from '@savgroup-front-common/configuration/api';
import {
  COMMON_QUERY_PARAMS,
  SUPPORTED_METHODS,
} from '@savgroup-front-common/constants/shared';
import {
  buildUrl,
  prepareResponseFailure,
} from '@savgroup-front-common/core/helpers';
import { apiCall } from '@savgroup-front-common/core/services';
import {
  BackResponse,
  BackResponseFailure,
  ReverseMoneyNumberAmount,
} from '@savgroup-front-common/types';

export const QUOTE_MARGIN_TYPE = {
  PERCENTAGE: 'Percentage',
  AMOUNT: 'Amount',
} as const;

export type QuoteMarginType =
  (typeof QUOTE_MARGIN_TYPE)[keyof typeof QUOTE_MARGIN_TYPE];

export interface QuoteMarginTier {
  toPrice: ReverseMoneyNumberAmount;
  margin: number;
}

export interface QuoteMarginRepairerConfiguration {
  repairerId: string;
  repairerName: string;
  marginType: QuoteMarginType;
  tiers?: QuoteMarginTier[];
}

export interface QuoteMarginConfiguration {
  sellerId: string;
  isActive: boolean;
  marginType: QuoteMarginType;
  tiers?: QuoteMarginTier[];
  repairerConfigurations?: QuoteMarginRepairerConfiguration[];
}

const ENDPOINT = `${APIConfiguration.repairer}sellers/${COMMON_QUERY_PARAMS.SELLER_ID}/quoteMargin`;

interface GetQuoteMarginConfigurationArgs {
  sellerId: string;
}

export default async function getQuoteMarginConfigurationQuery(
  payload: GetQuoteMarginConfigurationArgs,
): Promise<BackResponse<QuoteMarginConfiguration> | BackResponseFailure> {
  try {
    const url = ENDPOINT.replace(
      COMMON_QUERY_PARAMS.SELLER_ID,
      payload.sellerId,
    );

    return await apiCall<BackResponse<QuoteMarginConfiguration>>(
      buildUrl(url),
      { method: SUPPORTED_METHODS.GET },
    );
  } catch (exception) {
    return prepareResponseFailure(exception);
  }
}
